import React from 'react';
import { Modal, Form, Input, Switch, FormInstance } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { IClientIntegration, ClientIntegrationFormFields } from '@/ts/common-types';
import { ChannelIntegrationConfig } from '@/ts/common-types';

interface EditClientChannelIntegrationModalProps {
    isOpen: boolean;
    onCancel: () => void;
    onSubmit: () => Promise<void>;
    editingIntegration: IClientIntegration | null;
    form: FormInstance;
    channelConfig: ChannelIntegrationConfig | null;
}

const EditClientChannelIntegrationModal: React.FC<EditClientChannelIntegrationModalProps> = ({
    isOpen,
    onCancel,
    onSubmit,
    editingIntegration,
    form,
    channelConfig
}) => {
    if (!channelConfig || !editingIntegration) {
        return null;
    }

    const renderFormFields = () => {
        if (!channelConfig) return null;
        
        return channelConfig.authFields.map(field => (
            <Form.Item
                key={field.id}
                name={field.id}
                label={field.label}
                rules={[{ required: field.required, message: `Please enter ${field.label}` }]}
            >
                {field.id === 'password' ? (
                    <Input.Password placeholder={field.placeholder} className="border"/>
                ) : (
                    <Input placeholder={field.placeholder} className="border"/>
                )}
            </Form.Item>
        ));
    };

    return (
        <Modal
            title={
                <div className="d-flex align-items-center">
                    {channelConfig.logo && typeof channelConfig.logo === 'object' && 'type' in channelConfig.logo ? 
                        React.cloneElement(channelConfig.logo, { 
                            width: "2.5rem", 
                            height: "2.5rem",
                            className: "me-3" 
                        }) : 
                        <div className="me-3" style={{ width: "2.5rem", height: "2.5rem" }}></div>
                    }
                    <div>
                        <div className="h5 mb-0">Edit {channelConfig.name} Integration</div>
                        <div className="text-muted small">
                            Modify integration settings and credentials
                        </div>
                    </div>
                </div>
            }
            open={isOpen}
            onOk={onSubmit}
            onCancel={onCancel}
            okText="Save"
            cancelText="Cancel"
            width={500}
            className="edit-integration-modal"
        >
            <Form
                form={form}
                layout="vertical"
                className="py-3"
            >
                <Form.Item
                    name={ClientIntegrationFormFields.PlatformStatus}
                    valuePropName="checked"
                    label="Integration Status"
                >
                    <Switch />
                </Form.Item>

                <Form.Item
                    name={ClientIntegrationFormFields.JobPlatformName}
                    label={<span className="fw-medium">Platform Name</span>}
                >
                    <Input 
                        className="border"
                        disabled 
                        size="large"
                    />
                </Form.Item>

                {renderFormFields()}

                <div className="alert alert-info mt-4 mb-0 d-flex align-items-center">
                    <InfoCircleOutlined className="me-2 fs-5" />
                    <div>
                        <div className="fw-medium">Integration Details</div>
                        <div className="text-muted small">
                            Make sure all provided information is accurate before saving
                        </div>
                    </div>
                </div>
            </Form>
        </Modal>
    );
};

export default EditClientChannelIntegrationModal; 